import React, { createContext, useState, useRef } from 'react';
import axios from 'axios';
import config from '../config/config'

export const HospitalContext = createContext();

export function HospitalProvider(props) {

  const [hospitals, setHospitals] = useState([])
  const [hospitalCount, setHospitalCount] = useState(0)
  const [page, setPage] = useState(1)
  const lastSearchRef = useRef()

  const [hospitalUsers, setHospitalUsers] = useState([])


  const getHospitals = async (page, search, pageSize = 15) => {
    try {
      // ponytail: hospital paginated route has no `all` branch; 10000 matches getAllUsers pickers. Ceiling: hospitals beyond 10000 are omitted; upgrade is a server `count === 'all'` find-all.
      const fetchAll = pageSize === 'all'
      if (!fetchAll) lastSearchRef.current = search
      const response = await axios.put(`${config.apiUrl}/api/hospital/paginated/${page}/${fetchAll ? 10000 : pageSize}`, null, {
        params: { search }
      });
      if (!fetchAll) setHospitals(response.data);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const getHospitalCount = async (search) => {
    try {
        const response = await axios.put(`${config.apiUrl}/api/hospital/count`, null, {
          params: { search }
        });
        setHospitalCount(response.data.count ?? response.data);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const editHospital = async (id, data) => {
    try {
      await axios.put(`${config.apiUrl}/api/hospital/${id}`, {data: data});
      const list = await getHospitals(page, lastSearchRef.current).catch(() => null)
      if (list && list.length === 0 && page > 1) {
        setPage(page - 1)
        getHospitals(page - 1, lastSearchRef.current).catch(() => {})
      }
      getHospitalCount(lastSearchRef.current).catch(() => {})
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const createHospital = async (data) => {
    try {
      await axios.post(`${config.apiUrl}/api/hospital/create`, {data : data} );
      const currentPage = page ?? 1
      const list = await getHospitals(currentPage, lastSearchRef.current).catch(() => null)
      if (list && list.length === 0 && currentPage > 1) {
        setPage(currentPage - 1)
        getHospitals(currentPage - 1, lastSearchRef.current).catch(() => {})
      }
      getHospitalCount(lastSearchRef.current).catch(() => {})
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const deleteHospital = async (id) => {
    try {
      const response = await axios.put(`${config.apiUrl}/api/hospital/delete/${id}`);
      const list = await getHospitals(page, lastSearchRef.current).catch(() => null)
      if (list && list.length === 0 && page > 1) {
        setPage(page - 1)
        getHospitals(page - 1, lastSearchRef.current).catch(() => {})
      }
      getHospitalCount(lastSearchRef.current).catch(() => {})
      return response
    } catch (err) {
      console.log(err);
      throw err;
    }
  }


  // manage user

  const getHospitalUsers = async (id) => {
    try {
      const response = await axios.get(`${config.apiUrl}/api/user/users/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }

  const createHospitalUser = async (data) => {
    try {
      await axios.post(`${config.apiUrl}/api/user/register-cms`, {data : data} );
      return getHospitalUsers(data.organization_id)
    }
    catch (err) {
      console.log(err);
      throw err;
    }
  }

  const editHospitalUser = async (id, data, organization_id) => {
    try {
      await axios.put(`${config.apiUrl}/api/user/user/${id}`, {data: data});
      return getHospitalUsers(organization_id)
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const deleteHospitalUser = async (id, organization_id, additionalData = {}) => {
    try {
      await axios.post(`${config.apiUrl}/api/user/user/delete/${id}`, {
        ...additionalData,
        data: { organization_id: String(organization_id), ...additionalData.data },
      });
      return getHospitalUsers(organization_id)
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  const resetHospitalUserPassword = async (password, id, organization_id) => {
    try {
      await axios.put(`${config.apiUrl}/api/user/user/password/${id}`, {data: {password: password}});
      return getHospitalUsers(organization_id)
    } catch (err) {
      console.log(err);
      throw err;
    }
  }


  return (
    <HospitalContext.Provider
      value={{
        page,
        setPage,
        hospitals,
        getHospitals,
        lastSearchRef,
        hospitalCount,
        getHospitalCount,
        createHospital,
        deleteHospital,
        hospitalUsers,
        setHospitalUsers,
        getHospitalUsers,
        createHospitalUser,
        editHospitalUser,
        deleteHospitalUser,
        resetHospitalUserPassword,
        editHospital
      }}
    >
      {props.children}
    </HospitalContext.Provider>
  );
}
